import React from "react";

import "../auth.css";
import "../list.css";
import {
  Icon,
  Grid,
  Tab,
  Label,
  Accordion,
  List,
  Menu,
  Image,
  Step,
  Segment,
  Header,
  Button,
  Divider,
  Input,
  Modal,
  Form,
  TextArea,
  Pagination,
  Checkbox,
  Radio,
  Item,
} from "semantic-ui-react";
import Select from "react-select";
import Table from "react-bootstrap/Table";

import axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBCard,
  MDBCardBody,
} from "mdbreact";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import { API_BASE_URL } from "../utils/endpoints";
//import Modal from "react-modal";

const modDelete = {
  marginTop: 200,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
};

const modDeletea = {
  marginTop: 200,
  marginLeft: "15%",
  height: "auto",
  textAlign: "left",
};

const modEdit = {
  marginTop: 200,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
};

const modEdita = {
  marginTop: 200,
  marginLeft: "15%",
  height: "auto",
  textAlign: "left",
};
const modAdd = {
  marginTop: 200,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
};

const modAdda = {
  marginTop: 200,
  marginLeft: "15%",
  height: "auto",
  textAlign: "left",
};
var categoryOptions = [];
var countryOptions = [];
var value_options = [];
var group_data = [];

const customStyles = {
  content: {
    left: "13%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
  },
};

class Category extends React.Component {
  state = { activeIndex: 0 };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      errors: null,
      id: "",
      group_contact: [],
      isArabic: false,
      persons: [],
      categoryName: "",
      category_id: "",

      modalIsOpenDeleteCategory: false,
      CategoryIdForeDeletCategory: "",
      CategoryNameForeDeleteCategory: "",
      totalpageGroup: "1",
      activePageGroup: 1,

      modalOpen: false,
      modalOpenAddGroup: false,
      modalOpenEditGroup: false,
      modalOpenDeleteGroup: false,
      modalOpenImportFromFile: false,
      modalOpenImportFromContact: false,
      modalOpenGroupsContacts: false,

      //////////// from add group //////////////
      groupName: "",
      selectedValues: [],
      categoryselect: "",
      category_id: "",
      options_sender: [],
    };

    this.openModalDeleteCategory = this.openModalDeleteCategory.bind(this);
    this.closeModalDeleteCategory = this.closeModalDeleteCategory.bind(this);
  }

  handleOpenAddCategory = () => this.setState({ modalOpenAddCategory: true });
  handleCloseAddCategory = () => this.setState({ modalOpenAddCategory: false });
  handleOpenEditCategory = () => this.setState({ modalOpenEditCategory: true });
  handleCloseEditCategory = () =>
    this.setState({ modalOpenEditCategory: false });
  handleOpenDeleteCategory = () =>
    this.setState({ modalOpenDeleteCategory: true });
  handleCloseDeleteCategory = () =>
    this.setState({ modalOpenDeleteCategory: false });

  handlePaginationChange = (e, { activePage }) => this.setState({ activePage });

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });

    var id = e.target.id;
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/findAllGroups";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/findAllGroups";
    }
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const groups = res.data.result.groups;
      var i;
      for (i = 0; i < groups.length; i++) {
        if (res.data.result.groups[i].group_id === id) {
          this.setState({
            group_contact: res.data.result.groups[i].group_contacts,
          });

          this.setState({
            total_group_contacts:
              res.data.result.groups[i].total_group_contacts,
          });
        }
      }
    });
  };

  openModalDeleteCategory(e) {
    this.setState({
      modalOpenDeleteCategory: true,
      CategoryIdForeDeletCategory: e.target.id,
      CategoryNameForeDeleteCategory: e.target.name,
    });
  }

  searchchange = (event) => {
    if (event.target.value != "") {
      //  document.querySelector(".view_search").style = "display:block";
      var token = reactLocalStorage.get("accessToken");

      reactLocalStorage.get("user_id_login");

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/" +
          event.target.value +
          "/searchContacts";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/" +
          event.target.value +
          "/searchContacts";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        if (res.data.result.contacts != undefined) {
          const personssearch = res.data.result.contacts;
          this.setState({ personssearch });
        }
      });
    }
  };

  closeModalDeleteCategory() {
    this.setState({ modalIsOpenDeleteCategory: false });
  }

  EditCategory = (event) => {
    reactLocalStorage.set("id_user_edit_category", event.target.id);
    reactLocalStorage.get("id_user_edit_category");

    //reactLocalStorage.set("id_user_edit_category_name", event.target.name);
    //window.location = "EditCategory";
    this.edit();
  };

  edit() {
    this.setState({ modalOpenEditCategory: true });

    this.setState({
      categoryname: reactLocalStorage.get("id_user_edit_category_name"),
    });
    this.setState({
      category_id: reactLocalStorage.get("id_user_edit_category"),
    });

    this.setState({ modalOpenEdit: true });

    var token = reactLocalStorage.get("accessToken");
    var id = reactLocalStorage.get("id_user_edit_category");

    var ip = API_BASE_URL;
    var page_num = this.state.activePage - 1;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/findAllCategories";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/findAllCategories";
    }

    var i;
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const persons = res.data.result.Categories;
      if (persons != undefined) {
        this.setState({ persons });

        if (res.data.result != undefined) {
          for (i = 0; i < res.data.result.Categories.length; i++) {
            if (res.data.result.Categories[i].id === id) {
              this.setState({
                category_name: res.data.result.Categories[i].category_name,
              });
              //this.setState({template_value:res.data.result.templates[i].template_value})
              reactLocalStorage.set(
                "id_user_edit_category_name",
                res.data.result.Categories[i].category_name
              );
            }
          }
        }
      }
    });
    /////////////////////////////////////////////////////////
  }

  DeletCategory = (event) => {
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");

    this.setState({ id: event.target.id });
    var data = "";
    var id_user = this.state.CategoryIdForeDeletCategory;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/deleteCategory/"+id_user
        
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/deleteCategory/"+id_user
        
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl,{}, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "success") {
            window.location = "category";
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });

      document.querySelector(".pink_color").style =
        "text-align:right;width: 20%;white-space: pre;";

      document.querySelector(".fixed_group").style =
        "margin-right: 0% !important;";
    }

    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      document.querySelector(".add_btn_group").style = "display:none";
    }
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var page_num = this.state.activePage - 1;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/findAllCategories";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/findAllCategories";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const persons = res.data.result.Categories;
      if (persons != undefined) {
        this.setState({ persons });
      }
    });

    this.setState({
      categoryname: reactLocalStorage.get("id_user_edit_category_name"),
    });
    this.setState({
      category_id: reactLocalStorage.get("id_user_edit_category"),
    });
  }

  handleChange = (event) => {
    this.setState({ categoryName: event.target.value });
  };

  handleSubmitAdd = (event) => {
    event.preventDefault();

    var token = reactLocalStorage.get("accessToken");
    var data = {
      user_id: reactLocalStorage.get("user_id_login"),
      category_name: this.state.categoryName,
    };
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/createCategory";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/createCategory";
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "failed") {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: response.data.result.ErrorDescription,
              animation: "bounce",
              time: 5000,
            });
          }

          window.location = "category";
        } else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        } else {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      });
  };

  handleSubmitEdit = (event) => {
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");

    const user = {
      category_name: this.state.categoryName,
      category_id: this.state.category_id,
    };
    var data = user;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/updateCategory";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/updateCategory";
    }

    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          window.location = "category";
        } else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        } else {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      });
  };
  render() {
    const { activePage, activePageGroup } = this.state;
    const { activeIndex } = this.state;

    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_category">
            <div className="category_main">
              <Grid columns={2} divided className="fixed_group">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo">
                    {/* <Segment>
                      <h3 className="text_style pink_color">
                        {i18n.t("Manage_Groups.label")}
                      </h3>
                    </Segment> */}

                    <Segment>
                      <h3 className="text_style pink_color">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />
                <Divider horizontal>
                  <Header as="h2">
                    <Icon name="user outline" color="black" />{" "}
                    {this.state.isArabic ? " دليل العناوين" : "Address Book"}
                  </Header>
                </Divider>
                <br />
                <Step.Group widths={2}>
                  <Step>
                    <Icon
                      name="users"
                      onClick={() => {
                        window.location = "group";
                      }}
                    />
                    <Step.Content>
                      <Step.Title>
                        <Header
                          as="h3"
                          onClick={() => {
                            window.location = "group";
                          }}
                        >
                          {" "}
                          {i18n.t("Groups.label")}{" "}
                        </Header>
                      </Step.Title>
                    </Step.Content>
                  </Step>
                  <Step active>
                    <Icon
                      name="list alternate outline"
                      onClick={() => {
                        window.location = "category";
                      }}
                    />
                    <Step.Content>
                      <Step.Title>
                        <Header
                          as="h3"
                          onClick={() => {
                            window.location = "category";
                          }}
                        >
                          {i18n.t("Category.label")}
                        </Header>
                      </Step.Title>
                    </Step.Content>
                  </Step>
                </Step.Group>

                <br />
                <br />
                <Button
                  floated={this.state.isArabic ? "left" : "right"}
                  icon
                  labelPosition="left"
                  basic
                  size="small"
                  onClick={this.handleOpenAddCategory}
                >
                  {this.state.isArabic ? " فئه جديدة" : " New Category"}
                  <Icon name="pencil alternate" color="black" />
                </Button>
                <br />
                <br />
                <br />
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head">
                    <tr>
                      <td> {i18n.t("Category_Name.label")} </td>
                      <td>{this.state.isArabic ? "إعدادات" : "Settings"}</td>
                    </tr>
                  </thead>
                  {this.state.persons.map((person) => (
                    <tbody>
                      <tr>
                        <td> {person.category_name}</td>

                        <td style={{ textAlign: "center" }}>
                          <Header as="h6">
                            <Icon
                            className="eye"
                            
                              name="trash alternate outline"
                              id={person.id}
                              onClick={this.openModalDeleteCategory}
                            />
                            <Icon
                            className="eye"
                             
                              name="edit alternate outline"
                              id={person.id}
                              onClick={this.EditCategory}
                            />
                          </Header>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </Table>
              </Segment>
            </div>
          </div>{" "}
        </div>

        {/* ////////////////////////////Modals ///////////////////////////////////////
         */}
        <Modal
         closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          size="tiny"
          className="add"
          open={this.state.modalOpenAddCategory}
          onClose={this.handleCloseAddCategory}
          size="small"
          style={this.state.isArabic ? modAdda : modAdd}
        >
          <Header
            content={this.state.isArabic ? "فئة جديدة" : "New Category"}
          />
          <Modal.Content>
            <Form
              style={{
                textAlign:
                  reactLocalStorage.get("lang") === "ar" ? "right" : "left",
              }}
            >
              <Form.Input
                fluid
                label={i18n.t("Name_of_Category.label")}
                placeholder={i18n.t("Name_of_Category.label")}
                onChange={this.handleChange}
                width={15}
              />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Submit.label")}
              onClick={this.handleSubmitAdd}
            />
            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={this.handleCloseAddCategory}
            />
          </Modal.Actions>
        </Modal>

        <Modal
         closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          size="tiny"
          className="add"
          open={this.state.modalOpenDeleteCategory}
          onClose={this.handleCloseDeleteCategory}
          size="small"
          style={this.state.isArabic ? modDeletea : modDelete}
        >
          <Header
            icon="trash"
            content={this.state.isArabic ? "حذف الفئة" : "Delete Category"}
          />
          <Modal.Content>
            <Header as="h3" textAlign="center">
              {" "}
              {i18n.t("deleteAprovalCategory.label")}
            </Header>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Yes.label")}
              onClick={this.DeletCategory}
            />
            <Button
              basic
              color="black"
              content={i18n.t("No.label")}
              onClick={this.handleCloseDeleteCategory}
            />
          </Modal.Actions>
        </Modal>

        <Modal
         closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          size="tiny"
          className="add"
          open={this.state.modalOpenEditCategory}
          onClose={this.handleCloseEditCategory}
          size="small"
          style={this.state.isArabic ? modEdita : modEdit}
        >
          <Header
            icon="edit outline"
            content={this.state.isArabic ? "تعديل الفئة" : "Edit Category"}
          />
          <Modal.Content>
            <Form
              style={{
                textAlign:
                  reactLocalStorage.get("lang") === "ar" ? "right" : "left",
              }}
            >
              <Form.Input
                fluid
                label={i18n.t("Name_of_Category.label")}
                onChange={this.handleChange}
                defaultValue={this.state.category_name}
                width={15}
              />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Submit.label")}
              onClick={this.handleSubmitEdit}
            />
            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={this.handleCloseEditCategory}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(Category);
